<kendo-dialog-titlebar (close)="cancel()">
  <div style="font-size: 18px; line-height: 1.3em">
    <span class="k-icon k-i-lock"></span>
    {{ title | translate }}
  </div>
</kendo-dialog-titlebar>
<!-- CONTENT -->

<div class="ss-popup-container">
  <kendo-grid
    [data]="gridView"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    [filter]="state.filter"
    [sortable]="true"
    [pageable]="pageable"
    [filterable]="true"
    [resizable]="true"
    [selectable]="true"
    scrollable="scrollable"
    [loading]="isLoading"
    class="ss-list-grid"
    (cellClick)="select($event)"
    (dataStateChange)="dataStateChange($event)"
  >
    <!-- COLUMNS -->

    <!-- ID -->

    <kendo-grid-column
      field="customerId"
      title="{{ 'module.customer.model.customerId' | translate }}"
      [width]="40"
      filter="numeric"
    ></kendo-grid-column>

    <!-- NAME -->

    <kendo-grid-column
      field="customerName"
      title="{{ 'module.customer.model.customerName' | translate }}"
      [width]="120"
    ></kendo-grid-column>

    <!-- IS ACTIVE -->

    <kendo-grid-column
      field="isActiveInSafestock"
      title="{{ 'module.customer.model.isActiveInSafestock' | translate }}"
      [width]="20"
      filter="boolean"
      ><ng-template kendoGridCellTemplate let-dataItem>
        <span
          *ngIf="dataItem.isActiveInSafestock"
          class="k-icon k-i-check"
        ></span></ng-template
    ></kendo-grid-column>
  </kendo-grid>
</div>
